module.exports = __webpack_public_path__ + "static/media/imagem4.8313584d.jpeg";